import { render } from "./BaList.vue?vue&type=template&id=e02a0fc0"
import script from "./BaList.vue?vue&type=script&lang=js"
export * from "./BaList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__